import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHeader, INCLUDE_ORGANIZATION_ID_HEADER } from '../../api';
import { environment } from '../../environments/environment';
import { OrganizationStorageService } from '../../organizations/organization-storage.service';

export function organizationInterceptorFn(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const shouldAddOrganizationHeader = req.context.get(INCLUDE_ORGANIZATION_ID_HEADER)
    && isApiUrl(req.url);

  if (!shouldAddOrganizationHeader) {
    return next(req);
  }

  const organizationStorageService = inject(OrganizationStorageService);
  const organizationId = organizationStorageService.organization()?.id ?? '';

  return next(
    req.clone({
      setHeaders: {
        [ApiHeader.OrganizationId]: organizationId,
      },
    }),
  );
}

function isApiUrl(url: string): boolean {
  const usesSameOriginApi = !environment.apiHost.length;

  return usesSameOriginApi
    ? url.startsWith('/')
    : url.startsWith(environment.apiHost);
}
